import tokens from "./tokens.json";

export default tokens;
